import { createApi } from '@reduxjs/toolkit/query/react';

import { ApiTag } from '../api-tags.enum';
import { HttpMethod } from '../http-method.enum';
import { UserDto } from '@/lib/types';
import { apiBaseQuery } from '../base-query';

export const usersApi = createApi({
  reducerPath: 'usersApi',
  tagTypes: [ApiTag.User],
  refetchOnReconnect: true,
  refetchOnFocus: true,
  baseQuery: apiBaseQuery,
  endpoints: (builder) => ({
    searchUserByEmail: builder.query<UserDto, string>({
      query: (email) => ({
        url: `/admins/users/search`,
        method: HttpMethod.Get,
        params: { email },
      }),
      providesTags: (result) =>
        result ? [{ type: ApiTag.User, id: result.id }] : [ApiTag.User],
    }),
    getUserById: builder.query<UserDto, string>({
      query: (userId) => `/admins/users/${userId}`,
      providesTags: (result, error, userId) =>
        result ? [{ type: ApiTag.User, id: userId }] : [ApiTag.User],
    }),
    assignPhysioToPatient: builder.mutation<
      { success: boolean },
      { userId: string; physioId: string }
    >({
      query: ({ userId, physioId }) => ({
        url: `/admins/users/${userId}/assign-physio`,
        method: HttpMethod.Post,
        body: { physioId },
      }),
      invalidatesTags: (result, error, { userId }) => [
        { type: ApiTag.User, id: userId },
      ],
    }),
  }),
});

export const {
  useLazySearchUserByEmailQuery,
  useSearchUserByEmailQuery,
  useGetUserByIdQuery,
  useAssignPhysioToPatientMutation,
} = usersApi;
